import { apiCall, ApiConfig } from '../../config/api'
import { getTypesAlertAction } from '../actions/typeAlertActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { TypeAlert } from '../../interfaces/TypeAlert/typeAlert'
import { GET_TYPE_ALERT } from '../types/typeAlertActionsTypes'
import { ApiResponse } from '../../typings/ApiResponse'

export function* getTypesAlertAsync() {
  try {
    const { status, data }: AxiosResponse<ApiResponse<TypeAlert>> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeAlertApi}`
    )
    if (status === 200) {
      yield put(getTypesAlertAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypesAlertAction([], serverError.message))
  }
}

export function* watchGetTypesAlertAsync() {
  yield takeEvery(GET_TYPE_ALERT, getTypesAlertAsync)
}
